module.exports = __webpack_public_path__ + "static/media/021-sun.2a28af04.svg";